<template>
  <div v-if="currentItemBlock !== undefined" id="content-page-table" class="table-fix-head" :style="fixHeadCalculatedStyle">
    <table class="table table-hover table-sm table-fit align-middle">
      <thead>
        <tr>
          <th>
            {{ $t('field.generic.item') }}
            <font-awesome-icon :icon="['fas', 'sort-up']" />
          </th>
          <th>{{ $t('field.generic.quantity') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in sortedList" :key="index">
          <td><ItemField :item="item.item" /></td>
          <td><QuantityField :quantity="item.quantity" :unit-name="item.item.baseUnitCode" :pad-length="maxQuantityLength" /></td>
        </tr>
      </tbody>
    </table>
  </div>
  <div v-else>
    <slot name="empty-list" />
  </div>

</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import { useItemsStore, useItemBlocksStore } from '@/stores';
import { ItemField, QuantityField } from '@/components/fields';
import ItemBlockPart from '@/models/frontend/ItemBlockPart';

const itemsStore = useItemsStore();
const itemBlocksStore = useItemBlocksStore();

const props = defineProps({
  itemblockId: { type: Number, required: true }
});

const offsetTop = ref(0);

onMounted(() => {
  offsetTop.value = document.querySelector('#content-page-table')?.getBoundingClientRect().top ?? 0;
});

const fixHeadCalculatedStyle = computed(() => {
  return {
    height: `calc(100vh - ${offsetTop.value}px)`,
  };
});

const mappedItemBlocks = computed(() => {
  return [...currentItemBlock.value.partItems].map((item) => {
    return new ItemBlockPart(item.id, itemsStore.getById(item.itemId), item.quantity);
  });
});

const sortedList = computed(() => {
  if (currentItemBlock.value === undefined) {
    return [];
  }
  return [...mappedItemBlocks.value].sort((a, b) =>
    a.item.name.localeCompare(b.item.name)
  );
});

const maxQuantityLength = computed(() => {
  return sortedList.value.reduce((acc, item) => Math.max(acc, item.quantity.toString().length), 0);
});

const currentItemBlock = computed(() => {
  return itemBlocksStore.getById(props.itemblockId)
});
</script>
